import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { getMessagePackToast, setMessagePackToast } from '../../../../store/slices/chatsSlice';
import { getProductForUserSegment } from '../../../../store/slices/paymentsSlice';
import Toast from '../../Toast';

/**
 * "20 messages added" (HORO-10679), shown when the customer lands back in the
 * conversation they bought from. Same treatment as the account-created toast —
 * `fullWidthProgress` — because the design asks for that one specifically.
 *
 * The count comes from the product, not from the purchase: by the time this
 * renders the confirmation screen has already cleared the purchase record.
 */
const MessagePackToast = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isVisible = useSelector(getMessagePackToast);
    const product = useSelector(getProductForUserSegment);
    const count = product?.limits?.messages?.count;

    return (
        <Toast
            show={isVisible && !!count}
            message={t('messagePackOffer.purchased', { total: count })}
            dismissLabel={t('liveReadings.toastDismiss')}
            onDismiss={() => dispatch(setMessagePackToast(false))}
            fullWidthProgress
        />
    );
};

export default MessagePackToast;
